<template>

<section class="bg-gray-100 py-12">
    <div class="container mx-auto px-5 text-center">
        <h2 class="text-3xl font-bold mb-8">À propos de nous</h2>
        <p class="mb-8">Nous nous efforçons d'offrir le meilleur service de recharge téléphonique en ligne. Notre mission est de connecter les gens du monde entier, en leur fournissant un moyen rapide, sûr et efficace de recharger leurs téléphones, peu importe où ils se trouvent.</p>
        
        <!-- Ajoutez ici d'autres éléments tels que des photos d'équipe, des témoignages, etc. -->

        <a href="/about-us" class="bg-blue-600 text-white px-5 py-3 rounded hover:bg-blue-500 transition duration-300">En savoir plus</a>
    </div>
</section>

</template>


